import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useRef, useState, useMemo } from 'react';
import { useApolloClient, useMutation } from '@apollo/client';
import { useGoogleReCaptcha } from '@magento/peregrine/lib/hooks/useGoogleReCaptcha';
import mergeOperations from '@magento/peregrine/lib/util/shallowMerge';
import { useCartContext } from '@magento/peregrine/lib/context/cart';
import { useUserContext } from '@magento/peregrine/lib/context/user';
import { useAwaitQuery } from '@magento/peregrine/lib/hooks/useAwaitQuery';
import { retrieveCartId } from '@magento/peregrine/lib/store/actions/cart';
import { useResources } from '../../../../pages/Resources/useResources';
import { setResources } from '../../store/actions/resources/asyncActions';
import { useHistory, useLocation } from 'react-router-dom';
import DEFAULT_OPERATIONS from './signIn.gql';
import { useEventingContext } from '@magento/peregrine/lib/context/eventing';
export var useSignIn = function useSignIn(props) {
  var getCartDetailsQuery = props.getCartDetailsQuery,
      setDefaultUsername = props.setDefaultUsername,
      showCreateAccount = props.showCreateAccount,
      showForgotPassword = props.showForgotPassword,
      _props$setError = props.setError,
      setError = _props$setError === void 0 ? function () {} : _props$setError;

  var _useResources = useResources(),
      refetch = _useResources.refetch;

  var history = useHistory();
  var location = useLocation();
  var operations = mergeOperations(DEFAULT_OPERATIONS, props.operations);
  var createCartMutation = operations.createCartMutation,
      getCustomerQuery = operations.getCustomerQuery,
      mergeCartsMutation = operations.mergeCartsMutation,
      signInMutation = operations.signInMutation;
  var apolloClient = useApolloClient();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isSigningIn = _useState2[0],
      setIsSigningIn = _useState2[1];

  var _useCartContext = useCartContext(),
      _useCartContext2 = _slicedToArray(_useCartContext, 2),
      cartId = _useCartContext2[0].cartId,
      _useCartContext2$ = _useCartContext2[1],
      createCart = _useCartContext2$.createCart,
      removeCart = _useCartContext2$.removeCart,
      getCartDetails = _useCartContext2$.getCartDetails;

  var _useUserContext = useUserContext(),
      _useUserContext2 = _slicedToArray(_useUserContext, 2),
      _useUserContext2$ = _useUserContext2[0],
      isGettingDetails = _useUserContext2$.isGettingDetails,
      getDetailsError = _useUserContext2$.getDetailsError,
      _useUserContext2$2 = _useUserContext2[1],
      getUserDetails = _useUserContext2$2.getUserDetails,
      setToken = _useUserContext2$2.setToken;

  var _useEventingContext = useEventingContext(),
      _useEventingContext2 = _slicedToArray(_useEventingContext, 2),
      dispatch = _useEventingContext2[1].dispatch;

  var _useMutation = useMutation(signInMutation, {
    fetchPolicy: 'no-cache'
  }),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      signIn = _useMutation2[0],
      signInError = _useMutation2[1].error;

  var _useGoogleReCaptcha = useGoogleReCaptcha({
    currentForm: 'CUSTOMER_LOGIN',
    formAction: 'signIn'
  }),
      generateReCaptchaData = _useGoogleReCaptcha.generateReCaptchaData,
      recaptchaLoading = _useGoogleReCaptcha.recaptchaLoading,
      recaptchaWidgetProps = _useGoogleReCaptcha.recaptchaWidgetProps;

  var _useMutation3 = useMutation(createCartMutation),
      _useMutation4 = _slicedToArray(_useMutation3, 1),
      fetchCartId = _useMutation4[0];

  var _useMutation5 = useMutation(mergeCartsMutation),
      _useMutation6 = _slicedToArray(_useMutation5, 1),
      mergeCarts = _useMutation6[0];

  var fetchUserDetails = useAwaitQuery(getCustomerQuery);
  var fetchCartDetails = useAwaitQuery(getCartDetailsQuery);
  var formApiRef = useRef(null);
  var setFormApi = useCallback(function (api) {
    return formApiRef.current = api;
  }, []);

  var handle = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _refetch;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (_refetch = refetch()) === null || _refetch === void 0 ? void 0 : _refetch.then(function (res) {
                dispatch(setResources(res.data.resourcesAll));
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handle() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleSubmit = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
      var email, password, _location$state, sourceCartId, recaptchaData, signInResponse, token, _yield$fetchUserDetai, data, destinationCartId;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              email = _ref2.email, password = _ref2.password;
              setIsSigningIn(true);
              setError(null);
              _context2.prev = 3;
              handle();

              if (location !== null && location !== void 0 && (_location$state = location.state) !== null && _location$state !== void 0 && _location$state.pdp) {
                history.goBack(-1);
              } // Get source cart id (guest cart id).


              sourceCartId = cartId; // Get recaptchaV3 data for login

              _context2.next = 9;
              return generateReCaptchaData();

            case 9:
              recaptchaData = _context2.sent;
              _context2.next = 12;
              return signIn(_objectSpread({
                variables: {
                  email: email,
                  password: password
                }
              }, recaptchaData));

            case 12:
              signInResponse = _context2.sent;
              token = signInResponse.data.generateCustomerToken.token;
              _context2.next = 16;
              return setToken(token);

            case 16:
              _context2.next = 18;
              return apolloClient.clearCacheData(apolloClient, 'cart');

            case 18:
              _context2.next = 20;
              return apolloClient.clearCacheData(apolloClient, 'customer');

            case 20:
              _context2.next = 22;
              return removeCart();

            case 22:
              _context2.next = 24;
              return getUserDetails({
                fetchUserDetails: fetchUserDetails
              });

            case 24:
              _context2.next = 26;
              return fetchUserDetails({
                fetchPolicy: 'cache-only'
              });

            case 26:
              _yield$fetchUserDetai = _context2.sent;
              data = _yield$fetchUserDetai.data;
              dispatch({
                type: 'USER_SIGN_IN',
                payload: _objectSpread({}, data.customer)
              }); // Create and get the customer's cart id.

              _context2.next = 31;
              return createCart({
                fetchCartId: fetchCartId
              });

            case 31:
              _context2.next = 33;
              return retrieveCartId();

            case 33:
              destinationCartId = _context2.sent;
              _context2.next = 36;
              return mergeCarts({
                variables: {
                  destinationCartId: destinationCartId,
                  sourceCartId: sourceCartId
                }
              });

            case 36:
              getCartDetails({
                fetchCartId: fetchCartId,
                fetchCartDetails: fetchCartDetails
              });
              _context2.next = 44;
              break;

            case 39:
              _context2.prev = 39;
              _context2.t0 = _context2["catch"](3);
              setError(_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message);
              if (process.env.NODE_ENV !== 'production') console.log(_context2.t0);
              setIsSigningIn(false);

            case 44:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 39]]);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [cartId, generateReCaptchaData, signIn, setToken, apolloClient, removeCart, createCart, fetchCartId, mergeCarts, getUserDetails, fetchUserDetails, getCartDetails, fetchCartDetails, dispatch, handle]);
  var handleForgotPassword = useCallback(function () {
    var formApi = formApiRef.current;

    if (formApi) {
      setDefaultUsername(formApi.getValue('email'));
    }

    showForgotPassword();
  }, [setDefaultUsername, showForgotPassword]);
  var handleCreateAccount = useCallback(function () {
    var formApi = formApiRef.current;

    if (formApi) {
      setDefaultUsername(formApi.getValue('email'));
    }

    showCreateAccount();
  }, [setDefaultUsername, showCreateAccount]);
  var errors = useMemo(function () {
    return new Map([['getUserDetailsQuery', getDetailsError], ['signInMutation', signInError]]);
  }, [getDetailsError, signInError]);
  return {
    errors: errors,
    handleCreateAccount: handleCreateAccount,
    handleForgotPassword: handleForgotPassword,
    handleSubmit: handleSubmit,
    isBusy: isGettingDetails || isSigningIn || recaptchaLoading,
    setFormApi: setFormApi,
    recaptchaWidgetProps: recaptchaWidgetProps
  };
};